
import Vue from 'vue'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App'
import 'es6-promise/auto'
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import router from './routes/router'
import store from './store/index.js'

Vue.config.productionTip = false

Vue.use(DashboardPlugin);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import Vuex from 'vuex'
Vue.use(Vuex)
import Toasted from 'vue-toasted';
Vue.use(Toasted)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import Loader from '@/components/loader/loader.vue'
Vue.component('Loader', Loader);
import ModelErrors from '@/components/model-errors/model-errors.vue'
Vue.component('ModelErrors',ModelErrors);

let configData = require('../static/config.json');
initVue(configData);
function initVue(configData){
	bind_AgGridKey(configData);
	new Vue({
		el: '#app',
		router,
		store,
		template: '<App/>',
		render: h => h(App)
	})
}
function bind_AgGridKey(configData){
	if(!configData)return;
	//let agGridKey=configData.agGridKey;
	//LicenseManager.setLicenseKey(agGridKey);
}

